import { IntlMessageKeys } from 'config/translations';

export interface OAuthError {
  error: string;
  error_description: string;
}

export interface ApiFieldError {
  field: string;
  message: string;
}

export interface ApiError {
  reasons: Array<string>;
  code: ErrorCode;
  message: string;
}

export interface ParsedApiError {
  error: string;
  message: string;
  reasons?: Array<string>;
}

export interface ErrorMessages {
  [key: string]: string;
}

export enum ErrorCode {
  NotFound = 'APP.NF',
  Unknown = 'UNKNOWN',
  FacilityAlreadyAssignedToGroup = 'VENUE_GROUP.SPORT_FACILITY_ALREADY_ASSIGNED_TO_GROUP',
}

export const errorMessageMap: Record<ErrorCode | string, IntlMessageKeys> = {
  [ErrorCode.NotFound]: 'error.default',
  [ErrorCode.Unknown]: 'error.unknown',
  [ErrorCode.FacilityAlreadyAssignedToGroup]:
    'error.facilityAlreadyAssignedToGroup',
};
